import React from 'react';
import { motion } from 'framer-motion';
const pains = ['Buscás recetas en YouTube que no están pensadas para el ingrediente argentino ni para vender', 'Tus alfajores se rompen, tu chipá queda duro, tus muffins no suben y no sabés por qué', 'Calculás el precio "a ojo" y al final del mes trabajaste mucho y ganaste poco', 'No sabés cuánto cobrar, te da vergüenza subir precios y terminás regalando tu trabajo', 'Tus fotos de WhatsApp no generan pedidos porque no sabés cómo mostrar lo que hacés', 'Cada finde empezás de cero sin un plan, sin un cronograma y sin saber qué producir', 'Lunes a lunes el mismo ciclo: cocinás, vendés poco, no entendés qué falló'];
export function PainSection() {
  return <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-198">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-12" data-id="element-199">
        <h2 className="md:text-5xl font-bold mb-6 text-[40px]" data-id="element-200">
          ¿Cuántos Fines de Semana Más vas a Cocinar Sin Ganar lo que Merecés?
        </h2>
        <p className="text-lg text-carbon-lighter leading-relaxed max-w-3xl mx-auto" data-id="element-201">
          Tenés ganas de cocinar. Tenés el horno. Tenés los ingredientes. Pero
          nadie te dijo que ibas a pasar los domingos buscando recetas que no
          salen igual, calculando precios a ojo y vendiendo por debajo del costo
          sin saberlo.
          <br data-id="element-202" />
          <br data-id="element-203" />
          <span className="font-bold text-carbon" data-id="element-204">
            No es falta de talento. Es falta de un sistema.
          </span>
        </p>
      </motion.div>

      <div className="bg-white rounded-3xl p-8 md:p-12 shadow-warm border border-red-100 pt-[10px] pb-[10px]" data-id="element-205">
        <h3 className="text-xl font-bold text-red-800 mb-6 flex items-center gap-2" data-id="element-206">
          ❌ El Ciclo que se Repite Cada Semana:
        </h3>
        <ul className="space-y-4" data-id="element-207">
          {pains.map((pain, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-3 text-carbon-lighter" data-id="element-208">
              <span className="text-red-500 mt-1 flex-shrink-0" data-id="element-209">❌</span>
              <span data-id="element-210">{pain}</span>
            </motion.li>)}
        </ul>
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="text-center mt-12" data-id="element-211">
        <h3 className="text-2xl md:text-3xl font-bold text-brand-green italic font-[Avenir,_sans-serif]" data-id="element-212">
          ¿Y si este fuera el último finde que pasás así?
        </h3>
      </motion.div>
    </section>;
}